<template>
  <label class="flex justify-start items-start">
    <div
      :class="{
        'bg-trueBlue border-trueBlue': model && !disabled,
        'bg-sonicSilver': model && disabled,
        'border-sonicSilver': disabled,
      }"
      class="relative bg-white border-2 border-black rounded w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2"
    >
      <input
        type="checkbox"
        v-model="model"
        class="opacity-0 absolute"
        :disabled="disabled"
        @click.stop
      />
      <svg
        class="fill-current hidden w-3 h-3 text-white pointer-events-none"
        viewBox="0 0 20 20"
      >
        <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
      </svg>
    </div>
    <div
      :class="{
        'text-trueBlue': model && !disabled,
        'text-sonicSilver': disabled,
      }"
      class="select-none text-sm font-bold"
    >
      {{ label }}
    </div>
  </label>
</template>

<script>
  export default {
    name: 'BaseCheckbox',

    props: {
      label: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      model: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  input:checked + svg {
    display: block;
  }
</style>
